import { Paragraph } from '@almbrand/paragraph';

type ParagraphType = {
	kind: 'paragraph';
	size: 'default' | 'sm' | 'lg';
};

type LabelType = {
	kind: 'label';
	size: 'default' | 'sm' | 'xl';
};

type TitleType = {
	kind: 'title';
	type: 'standfirst' | 'title';
};

type FontColors =
	'primary' | 'primaryDark' | 'primaryLight' | 'black' | 'white' | 'secondaryDarkGrey' | 'secondaryGrey';

interface ParagraphComponentProps {
	text: string;
	fontColor?: FontColors;
	textDecoration?: 'default' | 'bold' | 'italic' | 'underline' | 'line-through';
	paragraphType: string;
	contentType?: string;
	contentId?: number;
}

export const ParagraphComponent: React.FC<ParagraphComponentProps> = ({
	text,
	contentId,
	paragraphType,
	contentType,
	fontColor,
	textDecoration,
}) => {
	const mapParagraphType = (paragraphType: string): ParagraphType | LabelType | TitleType => {
		const [kind, value] = paragraphType.split('-');

		switch (kind) {
			case 'paragraph':
				return { kind: 'paragraph', size: value as ParagraphType['size'] };
			case 'label':
				return { kind: 'label', size: value as LabelType['size'] };
			case 'title':
				return { kind: 'title', type: value as TitleType['type'] };
		}
	};

	return (
		<Paragraph
			paragraphType={mapParagraphType(paragraphType)}
			text={text}
			fontColor={fontColor}
			textDecoration={textDecoration}
		/>
	);
};
